import { createPinia } from 'pinia'
import { createPersistedState } from 'pinia-plugin-persistedstate' // 数据持久化

const pinia = createPinia()

pinia.use(
  createPersistedState({
    storage: {
      getItem: uni.getStorageSync,
      setItem: uni.setStorageSync,
    },
  }),
)

export default pinia

export * from './tabbar'
export * from './user'
export * from './points'
export * from './address'
export * from './order'
export * from './mallConfig'
